import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneEnabledOutlinedIcon from "@mui/icons-material/PhoneEnabledOutlined";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import NWONLogo from "../../../../public/media/svg/nwon_logo_dark.svg";
import {
  upToMediumDevices,
  upToSmallDevices,
} from "../../../helpers/clientSide/constants";
import {
  NWONTrackingEvent,
  trackEvent,
} from "../../00-globals/TruendoGoogleTagManager/trackEvent";
import { NWONCopyToClipboardButton } from "../../02-molecules/NWONCopyToClipboardButton/NWONCopyToClipboardButton";
import NWONSection from "../NWONSection/NWONSection";
import { NWONCTASectionProps } from "./NWONCTASectionInterfaces";
import { useNWONCTASectionStyles } from "./NWONCTASectionStyles";

const NWONCTASection = (props: NWONCTASectionProps): JSX.Element => {
  const { t } = useTranslation<"common">();
  const { classes } = useNWONCTASectionStyles();
  const { teamMember } = props;

  const copyText = t("footer.copyToClipboard");
  const copiedText = t("footer.copiedToClipboard");

  const theme = useTheme();
  const isSmallDevice = useMediaQuery(theme.breakpoints.down("md"));

  const handleAdConversion = () => {
    trackEvent(NWONTrackingEvent.AdConversion);
  };

  const bubbles = (
    <Grid item={true} xs={12} md={6} lg={4} className={classes.bubblesWrapper}>
      <Box className={classes.teamMemberBubble}>
        <Image
          src={teamMember.image}
          alt={teamMember.lastName}
          placeholder="blur"
          layout="responsive"
          sizes={`${upToSmallDevices} 100vw, ${upToMediumDevices} 50vw, 33vw`}
        />

        <Box className={classes.logoBubble}>
          <NWONLogo />
        </Box>
      </Box>
    </Grid>
  );

  return (
    <NWONSection
      className={classes.wrapper}
      useBackgroundColorPrimaryMain={true}
      additionalPadding={true}
    >
      <Grid container={true} className={classes.innerWrapper}>
        <Grid item={true} xs={12} md={6} lg={8}>
          <Typography variant="h2" className={classes.title}>
            {props.title}
          </Typography>

          {isSmallDevice && bubbles}

          <Typography
            variant="h4"
            color="secondary"
            className={classes.teamMemberName}
          >{`${teamMember.firstName} ${teamMember.lastName}`}</Typography>

          <Typography variant="body1" className={classes.subtitle}>
            {props.subTitle}
          </Typography>

          <Grid container={true} className={classes.buttonsWrapper}>
            <Grid item={true} className={classes.buttonWrapper}>
              <NWONCopyToClipboardButton
                buttonGroupColor="primary"
                leftButtonProps={{
                  startIcon: <EmailOutlinedIcon />,
                  component: "a",
                  href: `mailto:${teamMember.email}`,
                  children: teamMember.email,
                }}
                buttonGroupVariant="outlined"
                textToCopy={teamMember.email}
                copyTooltipText={copyText}
                copiedTooltipText={copiedText}
                buttonOnClick={handleAdConversion}
                copyOnClick={handleAdConversion}
              />
            </Grid>

            <Grid item={true} className={classes.buttonWrapper}>
              <NWONCopyToClipboardButton
                buttonGroupColor="primary"
                leftButtonProps={{
                  startIcon: <PhoneEnabledOutlinedIcon />,
                  component: "a",
                  href: `tel:${teamMember.phoneNumber}`,
                  children: teamMember.phoneNumber,
                }}
                buttonGroupVariant="outlined"
                textToCopy={teamMember.phoneNumber}
                copyTooltipText={copyText}
                copiedTooltipText={copiedText}
                buttonOnClick={handleAdConversion}
                copyOnClick={handleAdConversion}
              />
            </Grid>
          </Grid>
        </Grid>

        {!isSmallDevice && bubbles}
      </Grid>
    </NWONSection>
  );
};

export default NWONCTASection;
